// src/experiments/registry.js
//
// The list of experiments the app assigns from: the in-code config, merged
// with the remote document once one has been validated (traffic and force
// only). remoteConfig.js swaps the merged list in at boot from the cached
// copy, and on route changes after a fresh fetch.

import { EXPERIMENTS } from './experiments.config';

let current = EXPERIMENTS;
let meta = {};

export function getExperiments() {
  return current;
}

export function findExperiment(key) {
  return current.find((experiment) => experiment.key === key) || null;
}

// Where an experiment's effective values came from, recorded on every
// exposure so a result can be reconstructed afterwards.
export function getMeta(key) {
  return meta[key] || { source: 'code', force: 'none', hard: false };
}

// The remote forces in effect, in the shape assignAll() consumes.
export function getRemoteForces() {
  const forces = {};
  for (const [key, entry] of Object.entries(meta)) {
    if (entry && entry.force && entry.force !== 'none') {
      forces[key] = { force: entry.force, hard: Boolean(entry.hard) };
    }
  }
  return forces;
}

export function setExperiments(list, metaByKey = {}) {
  current = Array.isArray(list) ? list : EXPERIMENTS;
  meta = metaByKey && typeof metaByKey === 'object' ? metaByKey : {};
}
